module.exports = __webpack_public_path__ + "img/ico-tiktok.d7457b4f.svg";